import SAPOMailConfig         from "@/SAPOMailConfig";
import HTTPService            from "@/js/Shared/Services/HTTP/HTTPService";
import MessagesForwardingItem from "../Collections/MessagesForwardingItem";

export { MessagesForwardingHTTPService as default };

/**
* Email Messages Forwarding HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesForwardingHTTPService {
  /**
   * Imp generic endpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

 /**
   * Calls backend api to fetch messages forwarding settings
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetchForwards() {
    let response = await HTTPService.post(
      this.endpoint + '/messagesForwarding',
      {
        'op' : 'getForwards'
      },
      'fetch_messages_forwarding',
    );

    return response;
  }

  /**
   * Calls backend api to add messages forwarding settings
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} payload messages forwarding request payload
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async saveForwards(payload) {
    let response = await HTTPService.post(
      this.endpoint + '/messagesForwarding',
      {
        'op'    : 'saveForwards',
        'params': payload
      },
      'save_messages_forwarding',
    );

    return response;
  }

  /**
   * Calls backend api to delete all forwards
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} payload messages forwarding request payload
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async deleteForwards(payload) {
    let response = await HTTPService.post(
      this.endpoint + '/messagesForwarding',
      {
        'op'    : 'deleteForwards',
        'params': payload
      },
      'delete_messages_forwarding',
    );

    return response;
  }
}